<template>
<v-container fluid>
    <!-- <v-row > -->
    <v-col cols="12">
        <v-row class="mb-8" justify="center">
            <h2>Оберіть сервіс:</h2>
        </v-row>
        <v-row justify="center">

            <v-alert type="info" color="infolight" class="cardheaderdark--text" v-show="emptyList">
                Наразi немає доступних сервісів
            </v-alert>

            <v-card class="elevation-4 ma-2" v-for="item in list" :key="item.id">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-card v-on="on" dark :color="item.color" class="pa-2" outlined tile :elevation="hover ? 10 : 0" height="200" width="200" @click="$router.push(item.route)">
                                    <v-img :src="item.logo" width="200"></v-img>
                                </v-card>
                            </template>
                            <span>{{item.description}}</span>
                        </v-tooltip>
                    </template>
                </v-hover>
            </v-card>

        </v-row>
    </v-col>
    <!-- </v-row> -->
</v-container>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {}
    },
    methods: {},
    created() {},
    computed: {
        list() {
            return this.$store.state.main.servicesList
        },
        emptyList() {
            return this.$store.state.main.emptyServiceList
        }
    }
}
</script>

<style>
</style>
